import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Box } from '@interstate/components/Box';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as dealLifecycleSelectors from '@makemydeal/dr-dash-store/selectors/dealLifecycleSelectors';

import ActionsInterstate from '../baseDealFooter/Actions.interstate';
import { DealDatesAndStatus } from '../dealLifecycle/DealDatesAndStatus.interstate';
import { ActionsContainer } from '../baseDealFooter/Footer.style.interstate';
import { CompactHeaderActionsWrapper } from './CompactUIHeaderActions.style';
import { CompactUIHeaderDealInfo } from '../compactUIHeader/CompactUIHeaderDealInfo';

export const CompactUIHeaderActions = () => {
    const theme = useInterstateTheme();
    const isDealCentralExperience = useSelector(dealerSelectors.isDealCentralExperience);
    const isDealLifeCycleEnabled = useSelector(featureToggleSelectors.isDealLifeCycleEnabled);
    const dealLifecycle = useSelector(dealLifecycleSelectors.getDealLifecycle);

    return (
        <CompactHeaderActionsWrapper theme={theme}>
            {isDealLifeCycleEnabled && dealLifecycle.status && (
                <Box className="deal-dates-and-status-container">
                    <DealDatesAndStatus>
                        <CompactUIHeaderDealInfo />
                    </DealDatesAndStatus>
                </Box>
            )}
            <ActionsContainer className="actions-container" theme={theme} isDealCentralExperience={isDealCentralExperience}>
                <ActionsInterstate buttonSize="sm" menuSize="sm" />
            </ActionsContainer>
        </CompactHeaderActionsWrapper>
    );
};
